import { render } from "./BienvenueView.vue?vue&type=template&id=c242bbae"
import script from "./BienvenueView.vue?vue&type=script&lang=js"
export * from "./BienvenueView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__